import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import type { ExploreItem } from '../types/onboarding';
interface ExploreGridProps {
  items: ExploreItem[];
}
export function ExploreGrid({
  items
}: ExploreGridProps) {
  return <div className="space-y-5" data-id="element-16" data-mp="3hxf51w9wtfwq">
      <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-17" data-mp="3hw403t4qa241">
        {items.map(item => {
        const Icon = item.icon;
        return <li key={item.name} className="group/card rounded-xl border border-white/10 bg-white/[0.05] p-4 transition-all duration-200 hover:-translate-y-1 hover:border-[#10b981]/45 hover:bg-[#10b981]/[0.07] hover:shadow-[0_0_0_1px_rgba(16,185,129,0.3),0_18px_50px_-20px_rgba(16,185,129,0.22)]" data-id="element-18" data-mp="38w8j37ohrcw3">
              <Icon className="h-5 w-5 text-white/55 transition-colors duration-200 group-hover/card:text-[#10b981]" aria-hidden="true" data-id="element-19" data-mp="3409sddfoxisi" />
              <h3 className="mt-3.5 font-mono text-[13.5px] font-semibold tracking-tight text-white" data-id="element-20" data-mp="12610fv3ey6ms">
                {item.name}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-white/75" data-id="element-21" data-mp="dz2jfx2uhnmg">
                {item.description}
              </p>
              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.18em] text-[#10b981]" data-id="element-22" data-mp="sm5hc4v2xyab">
                Ask us about it →
              </p>
            </li>;
      })}
      </ul>

      <div className="flex gap-3 rounded-xl border border-[#10b981]/25 bg-[#10b981]/[0.08] px-4 py-4 sm:px-5" data-id="element-23" data-mp="3w4yrs8ska709">
        <MessageCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#10b981]" aria-hidden="true" data-id="element-24" data-mp="3r6nj41e062jm" />
        <p className="text-[15px] leading-relaxed text-white" data-id="element-25" data-mp="8x4tyl3upwl2">
          Curious about any of these? Reach out and we&apos;ll walk you through it.
        </p>
      </div>
    </div>;
}